import AgTypography from '../../../stories/Styles/AgTypography';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useIntl } from 'react-intl';
import { AgColor } from '../../../stories/Styles/AgColor';
import { useNavigate } from 'react-router-dom';
import {
  setIsDirty_Member_Personal,
  setIsOpenUnsavedModal,
  setMember_Redirect_URL
} from '../../../redux/slices/member';
import AgButton from '../../../stories/Components/AgButton';
import AgModal from '../../../stories/AgModal';
import { useState } from 'react';
import { useAppDispatch } from '../../../redux/hooks';

const Index = (
  {
    headerName,
    isDirty
  }: {
    headerName: string;
    isDirty: boolean;
  }
) => {
  const messages = useIntl().formatMessage;
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [isOpenLocalUnsavedModal, setIsOpenLocalUnsavedModal] = useState<boolean>(false);
  const handleClickBack = () => {
    if (isDirty) {
      setIsOpenLocalUnsavedModal(true);
    } else {
      navigate(-1);
    }
  };

  return (
    <AgTypography style={{ display: 'flex', gap: '12px', flexGrow: 1, margin: '8px 16px 8px 215px', alignItems: 'center' }}>
      <AgTypography
        style={{ display: 'flex', gap: '12px', alignItems: 'center', cursor: 'pointer' }}
        onClick={handleClickBack}
      >
        <ArrowBackIcon style={{ height: '12px', width: '12px', color: AgColor.grey5 }} />
        <AgTypography contentStyle={'AP.H5.Medium'} style={{ color: AgColor.grey5 }} message={messages({ id: 'BACK' })} />
      </AgTypography>
      <AgTypography contentStyle={'AP.H5.Medium'} style={{ padding: '4px 8px', color: AgColor.secondaryDark }} message={headerName} />

      {/*unsaved modal*/}
      <AgModal
        closeIcon
        open={isOpenLocalUnsavedModal}
        onCloseModal={()=>{
          setIsOpenLocalUnsavedModal(false);
        }}
        title={messages({ id: 'MEMBER_UNSAVED_MODAL_TITLE' })}
        body={
          <AgTypography
            contentStyle={'AP.Paragraph.Large.Regular'}
            style={{ marginTop: '16px', marginBottom: '80px' }}
            message={messages({ id: 'MEMBER_UNSAVED_MODAL_TEXT' })}
          />
        }
        footer={
          <>
            <AgButton
              label={messages({ id: 'CANCEL' })}
              variant='outlined'
              style={{ marginRight: '32px' }}
              onClick={() => {
                setIsOpenLocalUnsavedModal(false);
              }}
            />
            <AgButton
              label={messages({ id: 'PROCEED' })}
              onClick={() => {
                dispatch(setIsOpenUnsavedModal(false));
                dispatch(setIsDirty_Member_Personal(false));
                navigate(-1);
                dispatch(setMember_Redirect_URL(''));
              }}
            />
          </>
        }
        footerSX={{
          boxSizing: 'border-box'
        }}
      />
    </AgTypography>
  );
};

export default Index;